module.exports = {
    setGTagUser(uid) {
        gtag('set', {'user_id': uid});
    }
}